import React, { useState, useEffect } from "react";
import "./../StylesPages/profile.css";

import {
  FormControl,
  FormErrorMessage,
  Textarea,
  Spacer,
  Select,
  Input,
  Button,
  useToast,
  Center,
} from "@chakra-ui/react";
import Parse from "parse";
import { useNavigate } from "react-router-dom";

function InfoProfile() {
  const toast = useToast();

  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [description, setDescription] = useState("");

  const [eNom, setENom] = useState(false);
  const [ePrenom, setEPrenom] = useState(false);
  const [eEmail, setEEmail] = useState(false);
  const [eRole, setERole] = useState(false);
  const [eDescription, setEDescription] = useState(false);

  const navigate = useNavigate();
  const role_list = ["recruteur", "candidat"];

  const handleSubmit = (e) => {
    let canSubmit = true;

    setENom(false);
    setEPrenom(false);
    setEEmail(false);
    setERole(false);
    setEDescription(false);

    if (nom) {
      if (nom.length === 0) {
        setENom(true);
        canSubmit = false;
      }
    } else {
      setENom(true);
      canSubmit = false;
    }
    if (prenom) {
      if (prenom.length === 0) {
        setEPrenom(true);
        canSubmit = false;
      }
    } else {
      setEPrenom(true);
      canSubmit = false;
    }
    if (email) {
      if (email.length === 0) {
        setEEmail(true);
        canSubmit = false;
      }
    } else {
      setEEmail(true);
      canSubmit = false;
    }
    if (role) {
      if (role.length === 0) {
        setERole(true);
        canSubmit = false;
      }
    } else {
      setERole(true);
      canSubmit = false;
    }

    if (canSubmit) {
      const currentUser = Parse.User.current();

      currentUser.set("nom", nom);
      currentUser.set("prenom", prenom);
      currentUser.set("email", email);
      currentUser.set("username", email);
      currentUser.set("description", description);

      currentUser.save().then(
        (currentUser) => {
          toast({
            title: "Account updated.",
            description: "We've updated your account for you.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        },
        (error) => {
          alert(
            "Failed to update user informations, with error code: " +
              error.message
          );
        }
      );
    }
  };

  const getInfoUser = async () => {
    const currentUser = Parse.User.current();
    if (!currentUser) {
      navigate("/");
    } else {
      setNom(currentUser.get("nom"));
      setPrenom(currentUser.get("prenom"));
      setEmail(currentUser.get("email"));
      setRole(currentUser.get("type"));
      setDescription(currentUser.get("description"));
    }
  };

  useEffect(() => {
    // logout
    // Parse.User.logOut().then(() => {
    //     const currentUser = Parse.User.current();  // this will now be null
    //   });
    getInfoUser();
  }, []);

  return (
    <Center>
      <div>
        <FormControl isInvalid={eNom} className="profileName">
          <Input
            w={["300px", "300px", "387px", "387px"]}
            marginTop={38}
            placeholder="Nom"
            bg="white"
            id="Nom"
            borderRadius="100px"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            errorBorderColor="red.300"
            marginBottom={"20px"}
          />

          {!eNom ? "" : <FormErrorMessage>Nom requis.</FormErrorMessage>}
        </FormControl>

        <FormControl isInvalid={ePrenom}>
          <Input
            placeholder="Prenom"
            bg="white"
            id="Prenom"
            borderRadius="100px"
            value={prenom}
            onChange={(e) => setPrenom(e.target.value)}
            errorBorderColor="red.300"
            marginBottom={"20px"}
          />

          {!ePrenom ? "" : <FormErrorMessage>Prenom requis.</FormErrorMessage>}
        </FormControl>

        <FormControl isInvalid={eEmail}>
          <Input
            placeholder="Adresse e-mail"
            bg="white"
            id="Email"
            borderRadius="100px"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            errorBorderColor="red.300"
            marginBottom={"20px"}
          />

          {!eEmail ? "" : <FormErrorMessage>e-mail requis.</FormErrorMessage>}
        </FormControl>

        <FormControl isInvalid={eDescription}>
          <Textarea
            placeholder="Ajoutez une description"
            bg="white"
            borderRadius="20px"
            errorBorderColor="red.300"
            marginBottom={"40px"}
            maxH={"225px"}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          {!eDescription ? (
            ""
          ) : (
            <FormErrorMessage>Description </FormErrorMessage>
          )}
        </FormControl>

        <Button
          bg="#F1404B"
          color={"white"}
          borderRadius="100px"
          errorBorderColor="red.300"
          float={"right"}
          mb={10}
          me={4}
          onClick={handleSubmit}
        >
          Valider
        </Button>
      </div>
    </Center>
  );
}

export default InfoProfile;
